// Allow position fixed
.offcanvas-pusher.offcanvas-pusher-content {
  transform: none;
}

uvex-dealerlocator {
  display: block;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  max-width: 1950px;
  background: #e3e3e3;
  min-height: auto;

  @media (min-width: 768px) {
    min-height: 650px;
  }

  .svg-fill-primary {
    fill: var(--brand-primary, #ff6600);
  }

  .svg-stroke-primary {
    stroke: var(--brand-primary, #ff6600);
  }

  .locations-container {
    position: relative;

    @media (min-width: 768px) {
      display: flex;
      flex-flow: row nowrap;
    }
  }

  uvex-google-map {
    transition: all 0.2s ease-in-out;
    padding-bottom: 50vh;
    margin: 0;
    height: calc(100vh - 165px);

    @media (min-width: 768px) {
      height: 650px;
      padding-left: 410px;
      padding-bottom: 0;
    }

    > .btn-area-search,
    > uvex-dealerlocator-location {
      transition: all 0.2s ease-in-out;
      position: absolute;
      left: 50%;
    }

    > uvex-dealerlocator-location {
      display: none;
      bottom: 0.5rem;
      width: 350px;
    }

    > .btn-area-search {
      top: 0.5rem;

      @media (min-width: 768px) {
        margin-left: 110px;
      }
    }

    .route {
      display: none;
    }
  }

  .details-open uvex-google-map {
    > uvex-dealerlocator-location {
      @media (min-width: 768px) and (max-width: 991px) {
        display: none;
      }
    }
  }

  uvex-google-map > uvex-dealerlocator-location {
    @media (min-width: 768px) and (max-width: 991px) {
      display: none;
    }
  }

  &.hide-locations uvex-google-map {
    padding-bottom: 0;

    @media (min-width: 768px) {
      padding-left: 0;
    }

    > .btn-area-search,
    > uvex-dealerlocator-location {
      transform: translate3d(-50%, 0, 0);
    }
    > .btn-area-search {
      margin-left: 0;
    }
    > uvex-dealerlocator-location {
      @media (max-width: 991px) {
        display: block;
      }
    }
  }

  .divider {
    display: flex;
    justify-content: flex-end;
    position: relative;
    opacity: 0.7;

    &:after {
      content: '';
      position: absolute;
      bottom: 6px;
      left: 0;
      border-bottom: 2px solid var(--brand-primary, #ff6600);
      width: calc(100% - 60px);
    }
  }

  .badge-primary {
    width: 50px;
    height: auto;
    border-radius: 5px;
    font-size: 0.625rem;
    padding: 0 5px;
    text-align: center;
  }

  uvex-dealerlocator-location + uvex-dealerlocator-location {
    margin-top: 0.5rem;

    @media (min-width: 768px) {
      margin-top: 1rem;
    }
  }

  .route {
    display: flex;
    flex-direction: column;
    align-self: end;
    color: var(--brand-primary, #ff6600);

    svg {
      width: 33px;
    }
  }

  .address-route {
    display: flex;
    justify-content: space-between;
  }

  .show-more {
    border: 0;
    background-color: transparent;
    color: var(--brand-primary, #ff6600);
    align-self: flex-start;
  }

  .locations-wrap {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #e3e3e3;
    width: 100%;
    transition: transform 0.2s ease-in-out;
    height: 50vh;
    display: flex;
    flex-direction: column;
    padding: 0.25rem;

    @media (min-width: 768px) {
      top: 140px;
      width: 410px;
      height: 500px;
      padding: 1rem 0.5rem 1rem 1rem;
    }
  }

  .locations {
    height: 100%;
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
  }

  .locations-wrap,
  uvex-dealerlocator-location-detail {
    transform: translate3d(0, 0, 0);
    will-change: trasform;
  }

  &.hide-locations .locations-wrap {
    transform: translate3d(0, 100%, 0);
  }

  &.hide-locations .locations-wrap,
  &.hide-locations uvex-dealerlocator-location-detail {
    @media (min-width: 768px) {
      transform: translate3d(-100%, 0, 0);
    }
  }

  &.hide-locations {
    .btn-hide-search {
      svg {
        transform: translateY(0%) rotate(180deg);
      }
    }
  }

  .empty-results {
    flex: 1 0;
    background: #fff;

    .empty-header {
      display: flex;
      align-items: center;

      h3 {
        margin: 0;
      }
    }

    svg {
      width: 2.5rem;
      margin: 1rem;
    }

    p {
      padding: 0 1rem;
      margin-bottom: 2rem;
    }

    button {
      width: calc(100% - 5rem);
      margin: 0 2.5rem;
    }
  }

  .gm-style-iw-c {
    > button {
      display: none !important;
    }
    .show-more {
      display: none;
    }
  }
}

.maps-search-form {
  background-color: #e3e3e3;
  padding: 1rem;
  width: 100%;
  transition: transform 0.2s ease-in-out;

  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 410px;
    transform: translate3d(0, 0, 0);
    will-change: trasform;

    .hide-locations & {
      transform: translate3d(-100%, 0, 0);
    }
  }

  h3 {
    margin: 0 0 0.5rem 0;
    font-weight: 400;
  }

  .reset-facets,
  .btn-filter {
    font-weight: 400;
    text-transform: none;
    font-size: 1rem;
    margin-left: 1rem;
    padding: 12px 20px;

    @media (min-width: 768px) {
      margin-left: 0;
      padding-left: 3rem;
    }

    svg {
      left: 0.5rem;
      width: 1.5rem;

      @media (min-width: 768px) {
        left: 0.75rem;
      }
    }

    .label {
      display: none;

      @media (min-width: 768px) {
        display: inline;
      }
    }

    .number-of-facets {
      margin-left: 0.5rem;

      &:before {
        content: '';
        width: 2px;
        height: 2px;
        border-radius: 50%;
        background-color: #fff;
        display: inline-block;
        margin: 0 0.25rem;
        position: relative;
        top: -0.25rem;
      }
    }
    @media (max-width: 767px) {
      &.active {
        &:before {
          content: '';
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: var(--brand-primary, #ff6600);
          position: absolute;
          top: 6px;
          right: 4px;
        }
      }
    }
  }

  .btn-filter {
    height: 2.5rem;
  }

  .reset-facets {
    margin-left: 0;
    display: inline-flex;
    border: 0;
    background: transparent;
    white-space: nowrap;
    color: var(--brand-primary, #ff6600);
    padding-left: 2.5rem;

    @media (max-width: 767px) {
      display: none;
    }

    &:hover {
      background-color: transparent;
      color: var(--brand-primary, #ff6600);
    }

    svg {
      width: 1.5rem;
    }
  }

  .searchfield-wrap {
    display: flex;
    flex-wrap: nowrap;

    @media (min-width: 768px) {
      flex-wrap: wrap;
    }
  }

  .form-group {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    @media (max-width: 767px) {
      width: calc(100% - 3.5rem);
      flex: 0 0 calc(100% - 3.5rem);
    }

    @media (min-width: 768px) {
      margin-bottom: 1rem;
    }
  }

  .btn-search {
    color: #fff;
    background-color: var(--brand-primary, #ff6600);
  }

  .btn-hide-search {
    position: absolute;
    right: -50px;
    top: 0;
    padding: 0;
    width: 2.5rem;
    background-color: #999999;

    svg {
      transition: transform 0.2s ease-in-out;
    }
  }
}

// Disable special heckel button styling
.layout-heckel uvex-dealerlocator .btn:after {
  display: none;
}
